import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useConceptOptions = () => {
  const concepts = useSelector((state) => state.resonance.concepts);

  const conceptOptions = useMemo(
    () =>
      concepts?.map((concept) => ({
        label: concept.name,
        value: concept.id,
      })),
    [concepts],
  );

  if (!concepts) {
    return undefined;
  }

  return conceptOptions;
};

export default useConceptOptions;
